// Colori agente/agenzia condivisi e DETERMINISTICI, garantiti UNIVOCI.
// L'assegnazione avviene per posizione in un elenco globale ordinato di agenzie
// (registrato via registerAgents), così ogni agenzia ottiene un colore diverso
// e coerente in Agenda, Attività Agenzie e Dashboard. L'ambra è riservata al
// Responsabile Commerciale e NON è nella palette delle agenzie.
export const AGENT_PALETTE = [
  { key: "emerald", chip: "bg-emerald-500 hover:bg-emerald-600", border: "border-l-emerald-500", badge: "border-emerald-300 bg-emerald-100 text-emerald-800", dot: "bg-emerald-500", hex: "#10B981" },
  { key: "violet", chip: "bg-violet-500 hover:bg-violet-600", border: "border-l-violet-500", badge: "border-violet-300 bg-violet-100 text-violet-800", dot: "bg-violet-500", hex: "#8B5CF6" },
  { key: "cyan", chip: "bg-cyan-500 hover:bg-cyan-600", border: "border-l-cyan-500", badge: "border-cyan-300 bg-cyan-100 text-cyan-800", dot: "bg-cyan-500", hex: "#06B6D4" },
  { key: "pink", chip: "bg-pink-500 hover:bg-pink-600", border: "border-l-pink-500", badge: "border-pink-300 bg-pink-100 text-pink-800", dot: "bg-pink-500", hex: "#EC4899" },
  { key: "indigo", chip: "bg-indigo-500 hover:bg-indigo-600", border: "border-l-indigo-500", badge: "border-indigo-300 bg-indigo-100 text-indigo-800", dot: "bg-indigo-500", hex: "#6366F1" },
  { key: "rose", chip: "bg-rose-500 hover:bg-rose-600", border: "border-l-rose-500", badge: "border-rose-300 bg-rose-100 text-rose-800", dot: "bg-rose-500", hex: "#F43F5E" },
  { key: "lime", chip: "bg-lime-500 hover:bg-lime-600", border: "border-l-lime-500", badge: "border-lime-300 bg-lime-100 text-lime-800", dot: "bg-lime-500", hex: "#84CC16" },
  { key: "fuchsia", chip: "bg-fuchsia-500 hover:bg-fuchsia-600", border: "border-l-fuchsia-500", badge: "border-fuchsia-300 bg-fuchsia-100 text-fuchsia-800", dot: "bg-fuchsia-500", hex: "#D946EF" },
  { key: "sky", chip: "bg-sky-500 hover:bg-sky-600", border: "border-l-sky-500", badge: "border-sky-300 bg-sky-100 text-sky-800", dot: "bg-sky-500", hex: "#0EA5E9" },
  { key: "red", chip: "bg-red-500 hover:bg-red-600", border: "border-l-red-500", badge: "border-red-300 bg-red-100 text-red-800", dot: "bg-red-500", hex: "#EF4444" },
  { key: "blue", chip: "bg-blue-500 hover:bg-blue-600", border: "border-l-blue-500", badge: "border-blue-300 bg-blue-100 text-blue-800", dot: "bg-blue-500", hex: "#3B82F6" },
  { key: "teal", chip: "bg-teal-500 hover:bg-teal-600", border: "border-l-teal-500", badge: "border-teal-300 bg-teal-100 text-teal-800", dot: "bg-teal-500", hex: "#14B8A6" },
  { key: "purple", chip: "bg-purple-500 hover:bg-purple-600", border: "border-l-purple-500", badge: "border-purple-300 bg-purple-100 text-purple-800", dot: "bg-purple-500", hex: "#A855F7" },
  { key: "green", chip: "bg-green-500 hover:bg-green-600", border: "border-l-green-500", badge: "border-green-300 bg-green-100 text-green-800", dot: "bg-green-500", hex: "#22C55E" },
  { key: "yellow", chip: "bg-yellow-500 hover:bg-yellow-600", border: "border-l-yellow-500", badge: "border-yellow-300 bg-yellow-100 text-yellow-800", dot: "bg-yellow-500", hex: "#EAB308" },
  { key: "slate", chip: "bg-slate-500 hover:bg-slate-600", border: "border-l-slate-500", badge: "border-slate-300 bg-slate-100 text-slate-800", dot: "bg-slate-500", hex: "#64748B" },
  { key: "orange", chip: "bg-orange-500 hover:bg-orange-600", border: "border-l-orange-500", badge: "border-orange-300 bg-orange-100 text-orange-800", dot: "bg-orange-500", hex: "#F97316" },
  { key: "stone", chip: "bg-stone-500 hover:bg-stone-600", border: "border-l-stone-500", badge: "border-stone-300 bg-stone-100 text-stone-800", dot: "bg-stone-500", hex: "#78716C" },
];

// Elenco globale ordinato dei nomi agenzia registrati nella sessione.
let ORDER = [];

export function registerAgents(names) {
  let changed = false;
  (names || []).forEach((n) => {
    const k = (n || "").trim();
    if (k && !ORDER.includes(k)) { ORDER.push(k); changed = true; }
  });
  if (changed) ORDER = [...ORDER].sort((a, b) => a.localeCompare(b));
}

function hashStr(s) {
  let h = 0;
  const str = (s || "").trim().toLowerCase();
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return h;
}

export function agentColor(name) {
  if (!name) return null;
  const key = name.trim();
  const idx = ORDER.indexOf(key);
  if (idx >= 0) return AGENT_PALETTE[idx % AGENT_PALETTE.length];
  return AGENT_PALETTE[hashStr(key) % AGENT_PALETTE.length];
}

export function agentColorHex(name) {
  const c = agentColor(name);
  return c ? c.hex : "#94A3B8";
}

// Tinta univoca e deterministica per agenzia (golden-angle sull'indice globale).
// Garantisce colori distinti anche con molte agenzie (>palette), applicata via stile inline.
export function agentHsl(name) {
  const key = (name || "").trim();
  if (!key) return "#94A3B8";
  let idx = ORDER.indexOf(key);
  if (idx < 0) idx = hashStr(key) % 360;
  const h = Math.round((idx * 137.508) % 360);
  const l = idx % 2 === 0 ? 52 : 43;
  return `hsl(${h} 68% ${l}%)`;
}
